import ajaxService from 'AjaxService';

class ModuleMap {
	constructor() {
		this._map = null;
		this._path = null;

		if (window.glow) {
			window.glow.moduleMap = this;
		} else {
			window.glow = { moduleMap: this };
		}
	}

	setPath(dir) {
		this._path = `${dir}moduleMap.json`;
	}

	require(module) {
		if (!this._map) {
			throw new Error('You must call initAsync() before using this function');
		}

		return this._map[module] && __webpack_require__(this._map[module]); // eslint-disable-line no-undef
	}

	listModules(substring) {
		if (!this._map) {
			throw new Error('You must call initAsync() before using this function');
		}

		const keys = Object.keys(this._map);
		return substring ? keys.filter((key) => key.toLowerCase().includes(substring.toLowerCase())) : keys;
	}

	initAsync() {
		return ajaxService.getAsync(this._path).then((map) => this._map = map);
	}
}

export default new ModuleMap();
